import { CartaProducto } from "../components/CartaProducto";
import { Filtros } from "../components/Filtros";
import { useState, useEffect } from 'react';
import axios from "../axios";
import images from '../images';
import styles from '../css/Productos.module.scss';
import Breadcrumb from "../components/BreadCrumb";
import { useSearchParams } from 'react-router-dom';
import { Select } from "../components/Select";
import { Loader } from "../components/Loader";
import { formatearJsonProductos } from "../functions";
import axiosRequest from "../axiosRequest";

export const Productos = ({ on_sale }) => {

    const [productos, setProductos] = useState([]);
    const [categorias, setCategorias] = useState([]);
    const [brands, setBrands] = useState([]);
    const [searchParams, setSearchParams] = useSearchParams();
    const brandsLink = searchParams.get('marcas');
    const categoriasLink = searchParams.get('category');
    const ordenLink = searchParams.get('order');
    const maxPrice = searchParams.get('max_price');
    const minPrice = searchParams.get('min_price');
    const [mostrarLoader, setMostrarLoader] = useState(true);
    const itemsSelect = [
        { text: "Relevancia", orderby: 'popularity', order: 'desc', i: 0 },//falta
        //{ text: "Más vendido", orderby: 'popularity', order: 'desc', i: 1 },
        //{ text: "Mayor descuento", orderby: 'title', order: 'asc', i: 2 },//falta
        { text: "Precio más alto", orderby: 'price', order: 'desc', i: 1 },
        { text: "Precio más bajo", orderby: 'price', order: 'asc', i: 2 },
        { text: "Nombre A-Z", orderby: 'title', order: 'asc', i: 3 },
        { text: "Nombre Z-A", orderby: 'title', order: 'desc', i: 4 }
    ];
    const [orden, setOrden] = useState(ordenLink ? itemsSelect[ordenLink] : itemsSelect[0]);
    const [categSelect, setCategSelect] = useState([]);
    const [brandsSelect, setBrandsSelect] = useState([]);

    useEffect(() => {
        if (!brandsLink && !categoriasLink && !ordenLink && !maxPrice && !minPrice) {
            buscarProductos();
        }
        else {
            var ordenAux = itemsSelect[0];
            if (ordenLink) {
                ordenAux = itemsSelect[ordenLink];
                setOrden(ordenAux)
            }
            if (categoriasLink)
                setCategSelect(categoriasLink.split(','))
            if (brandsLink)
                setBrandsSelect(brandsLink.split(',')) 
            console.log(brandsLink)
            const params = [];
            if (brandsLink) params.push(`marcas=${brandsLink}`);
            if (categoriasLink) params.push(`category=${categoriasLink}`);
            if (ordenLink) params.push(`orderby=${ordenAux.orderby}&order=${ordenAux.order}`);
            if (maxPrice) params.push(`max_price=${maxPrice}`);
            if (minPrice) params.push(`min_price=${minPrice}`);

            const query = params.length > 0 ? '?' + params.join('&') : '';

            buscarProductos(query);
        }
    }, [categoriasLink, brandsLink, ordenLink, maxPrice, minPrice])


    function buscarProductos(query = '') {
        setMostrarLoader(true)
        axiosRequest.get("/products" + (on_sale ? '?on_sale=true' + query.replace('?', '&') : query) )
            .onResponse((response) => {
                setProductos(formatearJsonProductos(response.data))
            })            
            .onFinally(()=>{
                setMostrarLoader(false)
            })
    }

    return (
        <>
            <div className={"container-fluid px-5 " + styles.mainProductos}>
                <div className="row">
                    <div className="col">
                        <Breadcrumb categorias={categorias} outlet={on_sale} brands={brands}/>
                    </div>
                    <div className="col col-5 w-auto mt-3">
                        <Select id={'ordenar'} text={'Ordenar por'} items={itemsSelect} onChange={setOrden} selectedValue={orden} />
                    </div>
                </div>

                <div className="row my-4">
                    <div className="col col-5 w-auto">
                        <Filtros buscarProductos={buscarProductos} setCategorias={setCategorias} orden={orden} setBrands={setBrands}
                            categoriasSeleccionadas={categSelect} marcasSeleccionadas={brandsSelect} minPriceSelect={Number(minPrice)} maxPriceSelect={Number(maxPrice)} 
                            outlet={on_sale} />
                    </div>
                    <div className="col text-center">
                        {mostrarLoader?
                        <Loader/>
                        :
                        productos.length > 0 ?
                            productos.map(function (elem, i) {
                                return (
                                    <CartaProducto idCarta={'prod' + i} producto={elem} className={'mb-4 text-start'} />
                                )
                            })
                            :
                            <p className="text-center fw-bold mt-5">No se encontraron productos</p>
                        }
                    </div>
                </div>
            </div>
        </>
    )

}